module.exports = __webpack_public_path__ + "static/media/1.5.90dc0ed9.png";